import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=0ff81f18"
import script from "./Competitors.vue?vue&type=script&lang=js"
export * from "./Competitors.vue?vue&type=script&lang=js"
import style0 from "./Competitors.vue?vue&type=style&index=0&id=0ff81f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports